import { manualYamadumiListRes } from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'
/**
 * 労務山積計算-手積山積結果取得API
 */
export class YamadumiManualGateway {
  static getYamadumiManualList = async (
    simulationYm: string,
    procurementNo: string,
    subNo: string,
    branchCd: string,
    expense: string,
    expenseSeq: string,
    displayStartYear: string
  ) => {
    return await yamadumiApi.get<manualYamadumiListRes>(
      '/api/simulation/yamadumi-manual',
      { simulationYm, procurementNo, subNo, branchCd, expense, expenseSeq, displayStartYear }
    )
  }
}
